export default "__VITE_ASSET__C5kTreXK__"